import { useState, useEffect } from 'react';
import { learningAPI } from '../services/api';

export const useZenCoins = () => {
    const [balance, setBalance] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const res = await learningAPI.getProfile();
                setBalance(res.data.profile.zen_coins || 0);
            } catch (err) {
                console.error('Failed to fetch ZenCoins:', err);
            } finally {
                setLoading(false);
            }
        };

        // Check if user is logged in
        const user = localStorage.getItem('user');
        if (!user) {
            setLoading(false);
            return;
        }

        fetchBalance();
    }, []);

    return { balance, loading };
};
